module.exports = __webpack_public_path__ + "static/img/star_empty.d5542d6f.png";